import { render, staticRenderFns } from "./AccuseMail.vue?vue&type=template&id=5f256d67&scoped=true"
import script from "./AccuseMail.vue?vue&type=script&lang=js"
export * from "./AccuseMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f256d67",
  null
  
)

export default component.exports